<div class="modal-body content width-500">
  <div class="layout-auto-1-auto">
    <h5 class="modal-header">{{data.action.title}}</h5>
    <div class="content" [style.min-height]="getModalMinHeight()">
      <p class="list-metadata">{{data.action.description}}</p>

      <ng-container *ngIf="showTerminInputs">
        <div class="grid cols-2" style="margin-bottom: 1rem">
          <label>
            <input type="radio"
                   name="terminType"
                   value="typ15"
                   [(ngModel)]="selectedTerminType">
            {{getRessource('Typ15')}}
          </label>
          <label>
            <input type="radio"
                   name="terminType"
                   value="typ90"
                   [(ngModel)]="selectedTerminType">
            {{getRessource('Typ90')}}
          </label>
        </div>

        <div *ngIf="selectedTerminType === 'typ15'" class="grid cols-2">
          <exg-input [(ngModel)]="terminDate"
                     type="date"
                     caption="{{getRessource('CaptionDate')}}"
                     name="terminDate"
                     [required]="true"></exg-input>
          <exg-input [(ngModel)]="terminTime"
                     type="time"
                     [step]="60"
                     caption="{{getRessource('CaptionTime')}}"
                     name="terminTime"
                     [required]="true"></exg-input>
        </div>

        <div *ngIf="selectedTerminType === 'typ90'">
          <exg-textarea [(ngModel)]="terminNote"
                        caption="{{getRessource('CaptionNote')}}"
                        name="terminNote"
                        [required]="true"
                        [minlength]="5"></exg-textarea>
        </div>
      </ng-container>

      <ng-container *ngIf="showAttachmentInput">
        <div style="font-weight: 500; padding: 0.5rem 0;">{{getRessource('SelectAttachment')}}</div>
        <div class="content" style="max-height: 300px; overflow-y: auto; border: 1px solid #ddd; border-radius: 4px;">
          <cdk-tree [dataSource]="ConfigAttachmentTable.dataSource" [treeControl]="ConfigAttachmentTable.treeControl">
            <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: ConfigAttachmentTable.hasChild" class="example-tree-node">
              <div class="list-row app-cursor-pointer" cdkTreeNodeToggle>
                <div class="grid-auto-1" style="padding:0.5rem">
                  <div class="list-avatar nobackground">
                    <i class="far fa-fw"
                       [class.fa-folder-open]="ConfigAttachmentTable.treeControl.isExpanded(node)"
                       [class.fa-folder]="!ConfigAttachmentTable.treeControl.isExpanded(node)">
                    </i>
                  </div>
                  <div class="layout-1-auto">
                    <div class="list-metadata" style="margin-left:0">
                      {{node.dokFolderCount}} {{getRessource('DocumentCount')}}
                    </div>
                    <div>
                      <ng-container *ngIf="node.source === 'document'">
                        {{enumSvc.getEnumerationText('DokTyp', node.dok_enmIdent_DokTyp)}}
                      </ng-container>
                      <ng-container *ngIf="node.source === 'report'">
                        {{getRessource('Reports')}}
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <div [hidden]="!ConfigAttachmentTable.treeControl.isExpanded(node)">
                <ng-container cdkTreeNodeOutlet></ng-container>
              </div>
            </cdk-nested-tree-node>

            <cdk-tree-node *cdkTreeNodeDef="let node" class="example-tree-node">
              <div class="list-row app-cursor-pointer" (click)="toggleSelection(node)">
                <div class="grid-auto-1" style="padding-left: 2rem;">
                  <div class="list-avatar nobackground">
                    <input type="checkbox" [checked]="isSelected(node)">
                  </div>
                  <div class="layout-1-auto">
                    <div>
                      <strong>{{node.dokName}}{{node.dokErw}}</strong>
                    </div>
                    <div class="list-metadata" style="margin-left:0">
                      {{appSvc.file.calcFileSize(node.dokGroesse, false)}} - {{node.dokLCD | excDate: 'Globals.DateTimeFormatShort'}}
                    </div>
                  </div>
                </div>
              </div>
            </cdk-tree-node>
          </cdk-tree>
        </div>

        <div *ngIf="attachmentList.selectedObjects.length > 0" style="margin-top: 0.5rem;">
          <strong>{{getRessource('Selected')}}:</strong>
          <div *ngFor="let doc of attachmentList.selectedObjects" class="list-metadata">
            {{doc.dokName}}{{doc.dokErw}}
          </div>
        </div>

        <div *ngIf="showWarningTyp11"
             style="background-color: #fff3cd; padding: 0.75rem; border-radius: 4px; margin-top: 1rem">
          <i class="fas fa-info-circle" style="margin-right: 0.5rem"></i>
          {{getRessource('Typ11Warning')}}
        </div>
      </ng-container>
    </div>
    <div class="spawn-modal-actions">
      <button class="md-btn" (click)="clickedSend()" [disabled]="!canSend()">
        {{getRessource('Send')}}
      </button>
      <button class="md-btn" (click)="close()">
        {{getGlobal('Cancel')}}
      </button>
    </div>
  </div>
</div>
